// extracted by mini-css-extract-plugin
module.exports = {"expressive-icon":"ExpressiveIcon_expressive-icon__vPWCg","fade-in":"ExpressiveIcon_fade-in__uiEC6","fallback":"ExpressiveIcon_fallback__DYIuC"};